<template>
  <div class="bg-white">
    <div class="mx-auto max-w-7xl divide-y divide-highlight px-6 py-24 sm:py-32 lg:px-8 lg:py-40">
      <h2 class="text-2xl font-bold leading-10 tracking-tight text-basecolor">
        {{ title }}
      </h2>
      <dl class="mt-10 space-y-8 divide-y divide-highlight">
        <div
          v-for="imprint in imprints"
          :key="imprint.id"
          class="pt-8 lg:grid lg:grid-cols-12 lg:gap-8"
        >
          <dt class="text-xl font-semibold leading-7 text-basecolor lg:col-span-5">
            {{ imprint.title }}
          </dt>
          <dd class="mt-4 lg:col-span-7 lg:mt-0">
            <div
              class="leading-7 text-basecolor external-text"
              v-html="imprint.content"
            />
          </dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  imprints: {
    type: Array,
    required: true,
  },
});
</script>

<style scoped></style>
